import { useTranslation } from 'react-i18next';
import { CheckoutCard } from '../components/CheckoutCard';

/**
 * Shown for an unknown or malformed token. It deliberately reveals nothing about whether the payment
 * exists, so the page cannot be used to probe for valid tokens (spec section 18).
 */
export function NotAvailablePage() {
  const { t } = useTranslation();

  return (
    <CheckoutCard>
      <div className="bp-result">
        <div className="bp-result__icon bp-result__icon--error" aria-hidden="true">
          !
        </div>
        <div className="bp-result__title">{t('checkout.notAvailable')}</div>
        <div className="bp-result__message">{t('checkout.securedBy')}</div>
      </div>
    </CheckoutCard>
  );
}
